module.exports = __webpack_public_path__ + "img/OverseaMember39.0a08f71e.jpg";